// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__18G0e","approved":"Status_approved__3o59V","rejected":"Status_rejected__Z9eWx","expired":"Status_expired__1W54t","label":"Status_label__2m1sX"};